import React from "react";

export default function GatewayAction({
  children,
  variant = "primary",
  className = "",
  type = "button",
  ...props
}) {
  const classes = ["gatewayAction", `gatewayAction--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <button type={type} className={classes} {...props}>
      <span className="gatewayAction__label">{children}</span>
    </button>
  );
}
